<div class="row">
    <div class="col-md-12 col-xs-12">
        <ag-grid-angular
        class="ag-theme-alpine"
        [gridOptions]="gridOptions"
        (gridReady)="gridSetting($event)"
        (firstDataRendered)="restoreGridState($event)"
        (paginationChanged)="saveGridState($event)"
        (sortChanged)="saveGridState($event)"
        [columnDefs]="columnDefs"
        [rowData]="voyagesLength"
        [domLayout]="'autoHeight'"
        [pagination]= "true"
        [paginationPageSize]="10"
        [paginationPageSizeSelector]="[10,20,30]"
        [enableCellTextSelection]="true"
        >
        </ag-grid-angular>
    </div>
</div>
<div class="row">
  <i>
    <ul>
      <li>1- No of Loading ports/No of discharge ports</li>
      <li>2- Berth time</li>
      <li>3- Length from loading to discharge</li>
      <li>4- Length between 2 loading NORs in days</li>
      <li>5- Laytimes are in hours</li>
    </ul>
  </i>
</div>